import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AudienceContentTemplateListItem } from "@foresting-tomorrow/api_types_firestore/dist/audienceContent";

type AudienceTemplatesState = {
  orgId: string | null;
  status: "idle" | "loading" | "ready" | "error";
  templates: AudienceContentTemplateListItem[];
};

const initialState: AudienceTemplatesState = {
  orgId: null,
  status: "idle",
  templates: [],
};

const audienceTemplates = createSlice({
  name: "audienceTemplates",
  initialState,
  reducers: {
    loading(state, action: PayloadAction<string>) {
      state.orgId = action.payload;
      state.status = "loading";
      state.templates = [];
    },
    loaded(state, action: PayloadAction<{ orgId: string; templates: AudienceContentTemplateListItem[] }>) {
      if (state.orgId !== action.payload.orgId) return;
      state.templates = action.payload.templates;
      state.status = "ready";
    },
    failed(state, action: PayloadAction<string>) {
      if (state.orgId === action.payload) state.status = "error";
    },
    upsert(state, action: PayloadAction<AudienceContentTemplateListItem>) {
      const index = state.templates.findIndex((template) => template.templateId === action.payload.templateId);
      if (index === -1) state.templates.push(action.payload);
      else state.templates[index] = action.payload;
    },
    removed(state, action: PayloadAction<string>) {
      state.templates = state.templates.filter((template) => template.templateId !== action.payload);
    },
    reset: () => initialState,
  },
});

export const { loading, loaded, failed, upsert, removed, reset } = audienceTemplates.actions;
export default audienceTemplates.reducer;

export const selectAudienceTemplates = (state: { audienceTemplates: AudienceTemplatesState }) =>
  state.audienceTemplates.templates;
export const selectAudienceTemplatesLoading = (state: { audienceTemplates: AudienceTemplatesState }) =>
  state.audienceTemplates.status === "loading";
